import React from 'react';
import { extractInlineStyles, extractChildElementInlineStyles } from '../utils';
const RichTextUnderline = ({ children, value }) => {
    const inlineStyles = Object.assign(Object.assign({}, extractInlineStyles(value)), extractChildElementInlineStyles(value, 'span'));
    return React.createElement("u", { style: inlineStyles }, children);
};
RichTextUnderline.displayName = 'RichTextUnderline';
export default RichTextUnderline;
//# sourceMappingURL=Underline.js.map